import React from "react";
import styles from "./BenefitSection.module.scss";
import Image from "next/image";

const BenefitsSection = () => {
  const benefits = [
    { text: "Increase conversion rates by up to 40%", checked: true },
    { text: "Reduce customer support costs by 60%", checked: true },
    { text: "Improve customer satisfaction scores", checked: true },
    {
      text: "Scale personalization across millions of customers",
      checked: true,
    },
    { text: "Optimize inventory management automatically", checked: true },
    { text: "Generate actionable insights from customer data", checked: true },
  ];
  return (
    <section id="benefits" className={styles.section}>
      <div className={styles.container}>
        <div className={styles.grid}>
          {/* Text Section */}
          <div className={styles.content}>
            <div className={styles.headingBlock}>
              <div className={styles.badge}>Measurable Results</div>
              <h2 className={styles.heading}>
                Transform Your Business with AI
              </h2>
              <p className={styles.subtext}>
                See immediate improvements in customer satisfaction, conversion
                rates, and operational efficiency.
              </p>
            </div>

            <div className={styles.benefitsList}>
              {benefits.map((benefit, index) => (
                <div key={index} className={styles.benefitItem}>
                  <Image
                    src="/features-icon2.webp"
                    alt="icon"
                    width={20}
                    height={20}
                    className={styles.checkIcon}
                  />
                  <span>{benefit.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Image Section */}
          <div className={styles.imageWrapper}>
            <Image
              src="https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&cs=tinysrgb&w=800"
              alt="Business Growth Analytics"
              width={800}
              height={533} 
              className={styles.image}
            />

            <div className={styles.overlay}>
              <div className={styles.overlayContent}>
                <div className={styles.stat}>+40%</div>
                <div className={styles.statLabel}>Conversion Rate</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
